import React from 'react';
import styled from 'styled-components'

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Box } from 'vqp-common'
import { RatingCell, CardTitle } from './'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    & .slider > .slider-frame > .slider-list {
        width: auto !important;
    }
`

const Card = styled(Box)`
    display: block;
    min-height: 0px; 
    min-width: 0px;
    height: 278px;
    padding: 20px;
    & .slick-arrow:before {
        color: ${props => props.theme.colors.darkGrey} !important;
    }
    & .slick-prev {
        left: -15px !important
    }
    & .slick-next {
        right: -15px !important
    }
`

const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3
}

export const RatingsList = ({ratings}) => {
    return (
        <Wrapper>
            <CardTitle>Comentários</CardTitle>
            <Card>
                <Slider {...sliderSettings} >
                    {ratings.map( (rating, i) => (
                        // <div>
                        <RatingCell
                            key={`rating#${i}`}
                            picture={rating.picture}
                            name={rating.name}
                            score={rating.score}
                            date={rating.date}
                            text={rating.text}
                        />
                        // </div>
                    ))}
                </Slider>
            </Card>
        </Wrapper>
    )
}

